import React from 'react';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import guestService from '../../services/api/guest';
import { getGuestsColumnDefs } from '../../components/common/rows/guestRow';
import AGTable from '../../components/table/aggrid';
import { Input, Button } from 'semantic-ui-react';
import {
  AdminTableNetworkSection,
  AdminTableContent,
} from 'src/assets/styles/components/AdminTable';

const PER_PAGE = 50;

const AllGuests = (props) => {
  const [loading, set_loading] = React.useState(false);
  const [totalRecords, set_totalRecords] = React.useState(0);
  const [inputs, setInputs] = React.useState({});

  const gridApiRef = React.useRef(null);
  const keywordRef = React.useRef('');

  const makeDatasource = () => ({
    getRows: (params) => {
      set_loading(true);
      const perPage = params.endRow - params.startRow || PER_PAGE;
      const currentPage = Math.floor(params.startRow / perPage) + 1;

      guestService
        .getAllGuests({ keyword: keywordRef.current, currentPage, perPage })
        .then((response) => {
          set_loading(false);
          if (response.data.success) {
            const rows = response.data.allGuests || [];
            const total =
              typeof response.data.total === 'number'
                ? response.data.total
                : params.startRow + rows.length;
            set_totalRecords(total);
            params.successCallback(rows, total);
          } else {
            set_totalRecords(0);
            params.successCallback([], 0);
          }
        })
        .catch((error) => {
          set_loading(false);
          if (error.response?.status === 404) {
            set_totalRecords(0);
            params.successCallback([], 0);
          } else {
            if (error.response) Swal.fire(error.response.data.message);
            params.failCallback();
          }
        });
    },
  });

  const applyFilters = () => {
    keywordRef.current = inputs.keyword || '';
    if (gridApiRef.current) {
      gridApiRef.current.setDatasource(makeDatasource());
    }
  };

  const onGridReady = (params) => {
    gridApiRef.current = params.api;
    keywordRef.current = inputs.keyword || '';
    params.api.setDatasource(makeDatasource());
  };

  const handleInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setInputs({ ...inputs, [name]: value });
  };

  const onEnter = (e) => {
    if (e.key === 'Enter') applyFilters();
  };

  const columnDefs = React.useMemo(() => getGuestsColumnDefs(props.history), [props.history]);

  return (
    <AdminTableNetworkSection>
      <AdminTableContent>
        <Button primary onClick={applyFilters}>
          Buscar
        </Button>
        <h2>Directorio de asistentes de Comunidad MDE</h2>
        <div className="options">
          <div className="search-query">
            <p>Buscar</p>
            <Input
              loading={loading}
              name={'keyword'}
              onChange={handleInputs}
              value={inputs.keyword || ''}
              placeholder="Buscar por nombre, apellido, email, cédula o celular..."
              onKeyPress={onEnter}
            />
          </div>
        </div>
      </AdminTableContent>

      <div>
        <p>Total de registros: {totalRecords}</p>
        <AGTable
          columnDefs={columnDefs}
          rowModelType="infinite"
          onGridReady={onGridReady}
          pagination
          paginationPageSize={PER_PAGE}
          cacheBlockSize={PER_PAGE}
          rowHeight={60}
          suppressDragLeaveHidesColumns={false}
          defaultCol={{ sortable: false, filter: false, floatingFilter: false }}
        />
      </div>
    </AdminTableNetworkSection>
  );
};

export default AllGuests;
